import type { RecordDetailHeaderPresentation } from "@kontextwerk/web-sdk/ui/layout/recordDetail/types"
import { mdiHomeOutline } from "@mdi/js"
import { archivePresentation } from "../../../../../../../_shared/_logic/archive-presentation"
import { formatAddressInline } from "../../../../../../../../../_shared/_logic/countries"

export const propertyRecordIcon = mdiHomeOutline

export const buildPropertyHeader = (property: Property): RecordDetailHeaderPresentation => {
  const address = formatAddressInline(property)

  return {
    icon: propertyRecordIcon,
    subtitle: property.archived_at
      ? archivePresentation(property.archived_at, property.archive_reason)
      : undefined,
    fields: address ? [{ id: "address", label: "Adresse", value: address }] : [],
  }
}
